import { render, staticRenderFns } from "./OEmptyState.vue?vue&type=template&id=cebe106e&"
import script from "./OEmptyState.vue?vue&type=script&lang=js&"
export * from "./OEmptyState.vue?vue&type=script&lang=js&"
import style0 from "./OEmptyState.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports